import styled from 'styled-components/native';
import { withDefaultTypographyProps } from '@sp/ui/v2/typography/index.shared';

const Subtitle = styled(withDefaultTypographyProps)`
  font-size: ${(props) => props.theme.FONT_SIZES.SUBTITLE.MOBILE}px;
`;

export default Subtitle;
